<template>
  <tr>
    <td colspan="10" class="bg-light text-center py-0">
      <h3 class="message">Sorry we can't seem to find the keyword you're looking for. Please try again.</h3>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'OpportunityListNotFound'
}
</script>

<style lang="scss" scoped="">
.message {
  padding: 150px 0;
}
</style>
